module.exports = __webpack_public_path__ + "static/media/cha-u-gae-name.182b17c3.svg";